import { ISOString } from '@shared/scenes/cards/agenda/utils';

export enum RangeSelection {
  start = 'start',
  middle = 'middle',
  end = 'end',
  single = 'single',
}

export interface CalendarDate {
  dateString: ISOString;
  label?: number;
  selected?: boolean;
  highlighted?: boolean;
  weekend?: boolean;
  today?: boolean;
  range?: RangeSelection;
  currentMonth?: boolean;
}
